import * as types from './action-types';
import { getCells } from './selectors';
import { range } from 'lodash';

export function setName(ascendancy, name) {
  return {
    type: types.SET_NAME,
    payload: name,
    ascendancy,
  }
}

export function setBirth(ascendancy, birth) {
  return {
    type: types.SET_BIRTH,
    payload: birth,
    ascendancy,
  }
}

export function setDeath(ascendancy, death) {
  return {
    type: types.SET_DEATH,
    payload: death,
    ascendancy,
  }
}

export function setPersonId(ascendancy, personId) {
  return {
    type: types.SET_PERSON_ID,
    payload: personId,
    ascendancy,
  }
}

export function setTextColor(ascendancy, color) {
  return {
    type: types.SET_TEXT_COLOR,
    payload: color,
    ascendancy,
  }
}

export function setBackground(ascendancy, background) {
  return {
    type: types.SET_BACKGROUND,
    payload: background,
    ascendancy,
  }
}

export function setBandColor(ascendancy, bandColor) {
  return {
    type: types.SET_BAND_COLOR,
    payload: bandColor,
    ascendancy,
  }
}

export function setInverted(ascendancy, inverted) {
  return {
    type: types.SET_INVERTED,
    payload: inverted,
    ascendancy,
  }
}

export function batchUpdateCells(cells) {
  return {
    type: types.BATCH_UPDATE_CELLS,
    payload: cells,
  }
}

export function clearAllCellsData() {
  const cellUpdates = range(2, 1024).map(i => ({ascendancy: i, name: '', birth: '', death: ''}));
  return batchUpdateCells(cellUpdates);
}

export function clearAncestorData(person) {
  const ascendancies = [];
  const queue = [person.ascendancy];
  while(queue.length) {
    const ascendancy = queue.pop();
    const father = ascendancy * 2;
    if(father < 1024) {
      queue.push(father, father + 1);
    }
    ascendancies.push(ascendancy);
  }

  const cellUpdates = ascendancies.map(ascendancy => ({ascendancy, name: '', birth: '', death: ''}));
  return batchUpdateCells(cellUpdates);
}

export function setCellFromFamilySearch(ascendancy, data) {
  return dispatch => {
    dispatch(setName(ascendancy, data.name || ''));
    dispatch(setBirth(ascendancy, data.birth || ''));
    dispatch(setDeath(ascendancy, data.death || ''));
    dispatch(setPersonId(ascendancy, data.death || ''));
  }
}

function generationAndIndexToAscendancy(generation, index) {
  return Math.pow(2, generation, index);
}

function ascendancyToGenerationAndIndex(ascendancy) {
  let count = 1;
  let generation = -1;
  while(count <= ascendancy) {
    count *= 2;
    generation++;
  }
  const index = ascendancy - (count / 2);
  
  return {index, generation};
}


// WEBPACK FOOTER //
// ./src/core/cells/actions.js